(ns ui.components.calculi-tree.events
  (:require
    [re-frame.core :as rf]))

(def empty-node {:calculi-type nil :rules []})

;; Event: Set a node's operator type and initialize its children
(rf/reg-event-db
  ::set-type
  (fn [db [_ tree-path new-type]]
    (let [child-count (case new-type
                        :calculi-type/operator-subtraction 1
                        :calculi-type/parenthesis-group 1
                        2)
          new-children (vec (repeat child-count empty-node))]
      (-> db
          ;; Ensure parent path is a vector, if it ends in an index
          (update-in (butlast tree-path)
                     (fn [coll]
                       (if (and (int? (last tree-path))
                                (not (vector? coll)))
                         (vec (repeat (inc (last tree-path)) {}))
                         coll)))
          ;; Set type and rules
          (assoc-in (conj tree-path :calculi-type) new-type)
          (assoc-in (conj tree-path :rules) new-children)))))

;; Event: Add a child to a node
(rf/reg-event-db
  ::add-child
  (fn [db [_ tree-path]]
    (update-in db (conj tree-path :rules)
               (fn [rules]
                 (conj (vec rules) empty-node)))))

;; Event: Remove a child at given index
(rf/reg-event-db
  ::remove-child
  (fn [db [_ tree-path idx]]
    (let [rules (get-in db (conj tree-path :rules))]
      (if (and (vector? rules)
               (<= 0 idx)
               (< idx (count rules)))
        (update-in db (conj tree-path :rules)
                   #(vec (concat (subvec % 0 idx)
                                 (subvec % (inc idx)))))
        (do
          (js/console.error "remove-child index out of bounds"
                            {:tree-path tree-path :index idx :rules rules})
          db)))))

;; Event: Set field value in a field node
(rf/reg-event-db
  ::set-field
  (fn [db [_ tree-path field-id]]
    (let [node-type (get-in db (conj tree-path :calculi-type))]
      (if (= :calculi-type/field node-type)
        (assoc-in db (conj tree-path :field) field-id)
        (do
          (js/console.error "set-field called on non-field node" {:tree-path tree-path :type node-type})
          db)))))

(rf/reg-event-db
  ::set-constant
  (fn [db [_ tree-path value]]
    (assoc-in db (conj tree-path :value) value)))

(rf/reg-event-db
  ::set-expression
  (fn [db [_ expression tree-path]]
    (assoc-in db tree-path [expression])))
